import React, { useRef } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useValidador } from '../../../utils/validador';
import TicketPropertySelector from '../../TicketProperty/TicketPropertySelector';

export default function EmailActivityModal(props) {
  const {
    ticketActivity,
    handleClose,
    handleChangeTicketActivity,
    email,
    open,
    ticket_property,
    disabled
  } = props;
  //Hooks
  let reglas = {};
  reglas = {
    text: ['required'],
    motive: ['required']
  };
  const [validador, validar] = useValidador(reglas);

  function handleAccept() {
    if (validador.isValid()) {
      props.handleAccept();
      if (ticketActivity.motive && ticketActivity.text && email) {
        window.open(
          `mailto:${email}?subject=${ticketActivity.motive}&body=${ticketActivity.text}`,
          '_self'
        );
      }
    }
  }

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Enviar WhatsApp</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Iniciaremos una conversación con WhatsApp
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="motive"
            label="Asunto"
            type="text"
            fullWidth
            value={
              ticketActivity && ticketActivity.motive
                ? ticketActivity.motive
                : ''
            }
            onChange={handleChangeTicketActivity}
            onBlur={validar}
            error={!validador.isValidById('motive')}
            helperText={validador.getHelperTextById('motive')}
            disabled={disabled}
          />
          <TextField
            margin="dense"
            id="text"
            label="Texto del mensaje"
            type="text"
            multiline
            rows={3}
            fullWidth
            value={
              ticketActivity && ticketActivity.text ? ticketActivity.text : ''
            }
            onChange={handleChangeTicketActivity}
            onBlur={validar}
            error={!validador.isValidById('text')}
            helperText={validador.getHelperTextById('text')}
            disabled={disabled}
          />
          <TicketPropertySelector
            model={ticketActivity}
            handleChangeModel={handleChangeTicketActivity}
            disabled={disabled}
            id={'property_id'}
            margin="dense"
            fullwidth={true}
            idsTicketProperties={ticket_property}
            description={'Propiedad'}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary" disabled={disabled}>
            Cancelar
          </Button>
          <Button onClick={handleAccept} color="primary" disabled={disabled}>
            Enviar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
